<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :fromBackend="true"
    />
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import SuretyInsuranceData from '@/data/company-page-data/quick-sigorta/cross-pages/SuretyInsurance'
export default {
  metaInfo: {
    title: 'Quick Sigorta Kefalet Sigortası Fiyatı İçin Teklifi Alın',
    meta: [
      {
        name: 'description',
        content: 'Quick Sigorta Kefalet sigortası genel şartlarına göre en uygun kefalet sigortası teklifini alın, banka teminat mektubu yerine kefalet sigortasına sahip olun.'
      }
    ]
  },
  name: 'QuickSigortaSuretyInsurance',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: SuretyInsuranceData.headerContent,
      crossPageContent: SuretyInsuranceData.crossPageContent,
      faqTitle: SuretyInsuranceData.faqTitle,
      faqTitleDesc: SuretyInsuranceData.faqTitleDesc,
      getPrice: SuretyInsuranceData.getPrice
    }
  }
}
</script>
